<template>
	<div class="container-fluid">

		<form-toolbar></form-toolbar>

		<div class="main-body">

			<div class="mb-4">
				<h2>Form Marketplace</h2>
			</div>

			<div class="mb-1">
				<h3>Featured Templates</h3>
			</div>


			<!------------------------- "Featured" Forms List ------------------------->

			<div class="row mb-4">
				<form-marketplace-template v-for="template in featuredTemplates" class="template-card" :template="template" v-on:click="openTemplateModal"></form-marketplace-template>
			</div>


			<h3>All Templates</h3>


			<!------------------------- Search Bar ------------------------->

			<div class="d-flex mb-2">

				<field
					style="min-width: 250px;"
					class="mr-3"
					:params="{type:'select',options: searchCategoryOptions}"
					v-model="searchCategory"></field>

				<div class="search-bar mr-3">
					<search-bar placeholder="eg. Safety Analysis..." :full-width="true" v-model="searchText"></search-bar>
				</div>

				<div>
					<button class="btn btn-primary" v-on:click="fetchTemplates">Search</button>
				</div>

			</div>


			<!------------------------- "All" Forms List ------------------------->

			<div class="row">
				<form-marketplace-template v-for="template in allTemplates" class="template-card" :template="template" v-on:click="openTemplateModal"></form-marketplace-template>
			</div>

		</div>


		<!------------------------- Form Preview Modal ------------------------->

		<modal-dialog
			title="Form Template"
			:modal-visible="templateModal.isVisible"
			modal-size="modal-lg"
			:submit-visible="false"
			v-on:closeModal="templateModal.isVisible = false">

			<div v-if="templateModal.template">

				<div class="mb-4">
					<h4>Title</h4>
					<p>{{templateModal.template.title}}</p>
				</div>

				<div class="mb-4">
					<h4>Description</h4>
					<p>{{templateModal.template.description}}</p>
				</div>

				<div class="mb-4">

					<h4>Import to a Template Category</h4>

					<div class="d-flex align-items-baseline mt-4 ml-3">

						<field
							class="mr-4"
							label="Category"
							col-class="col-auto"
							:params="{type:'select',options: companyCategoryOptions}"
							v-model="templateModal.importCategoryId">
						</field>

						<button class="btn btn-primary" v-on:click="importTemplate" :disabled="!templateModal.importCategoryId || templateModal.isWorking">
							<i class="fa fa-download"></i>
							Import
						</button>

					</div>

				</div>

				<div class="mb-3">
					<h4>Preview</h4>
					<form-fillable :value="templateModal.formData" :is-child-template="true"></form-fillable>
				</div>

			</div>

		</modal-dialog>

	</div>
</template>

<script>

import FormToolbar from "@/pages/forms/FormToolbar";
import Field from "@/components/Field"
import SearchBar from "@/components/SearchBar"

import FormMarketplaceTemplate from "@/pages/forms/FormMarketplaceTemplate";

import ModalDialog from "@/components/ModalDialog";
import FormFillable from "@/components/company_forms/FormFillable";

export default {
	name: "FormMarketplace",
	components: {
		FormToolbar,
		Field,
		SearchBar,
		FormMarketplaceTemplate,
		ModalDialog,
		FormFillable
	},
	data() {
		return {

			// Generic include for FormMarketplaceTemplate/get calls
			templateInclude: [
				{ model: 'UploadImage', fields: ['thumb_filename'] }
			],

			// Search bar values
			searchCategory: 'all',
			searchText: '',

			// Fetched values
			categories: [],          // list of FormMarketplaceCategory
			featuredTemplates: [],   // list of FormMarketplaceTemplate
			allTemplates: [],        // list of FormMarketplaceTemplate
			companyCategories: [],   // list of FormTemplateCategory

			// Template Preview Modal
			templateModal: {
				isVisible: false,         // Is the modal visible?
				template: null,           // Selected template
				formData: null,           // Parsed template.template_json
				importCategoryId: null,   // Selected FormTemplateCategory
				isWorking: false          // Are we in the process of importing the template?
			},


		}
	},

	computed: {

		companyCategoryOptions() {
			return this.optionify(this.companyCategories, 'name')
		},

		searchCategoryOptions() {
			return [{ text: 'All Categories', value: 'all'}, ...this.optionify(this.categories, 'name')]

		}

	},

	methods: {

		importTemplate() {
			/**
			 * Copies templateModal.template (type FormMarketplaceTemplate) to the
			 * user's company as a new template (type FormTemplate)
			 */

			let vm = this

			let template = this.templateModal.template

			let payload = {
				title: template.title,
				template_json: template.template_json,
				category_id: this.templateModal.importCategoryId
			}

			this.templateModal.isWorking = true

			this.postData('FormTemplate/save', payload).then(response => {

				if (response.success) {
					vm.templateModal.isVisible = false

					let category = vm.companyCategories.find(cat => cat.id == payload.category_id)
					let successMsg = "Template '" + template.title + "' has been imported to category '" + category.name + "'"
					vm.alertSuccess(successMsg, false)

				} else {
					vm.alertFail('Template could not be imported.')
				}

				this.templateModal.isWorking = false
			})
		},

		openTemplateModal(template) {

			try {
				this.templateModal.formData = JSON.parse(template.template_json)
				this.templateModal.template = template
				this.templateModal.importCategoryId = null
				this.templateModal.isVisible = true

			} catch (e) {
				this.alertFail('Selected form is invalid.  Please contact an administrator.')
			}

		},

		mutateTemplates(templates) {
			/**
			 * Generic mutate function for objects of type FormMarketplaceTemplate
			 * This is applied to both allTemplates and featuredTemplates
			 */
			templates.forEach(template => {
				template.FormMarketplaceCategory = this.categories.find(cat => cat.id == template.category_id)
			})
		},

		fetchTemplates() {
			/**
			 * Update allTemplates each time the user clicks the "Search" button
			 */

			let vm = this

			let searchTerms = this.searchText.split(' ').filter(t => t.length).map(t => t.toLowerCase())

			// We only want to use unique terms
			let terms = []
			searchTerms.forEach(term => {
				term = term.toLowerCase()
				if (terms.indexOf(term) == -1)
					terms.push(term)
			})

			// We want to convert the terms to filters
			let filters = []
			searchTerms.forEach(term => {
				filters.push(['description', term, 'and', 'like'])
			})

			// Also add category filter if we have it.  Now we are searching by both category + terms
			if (this.searchCategory != 'all')
				filters.push(['category_id', this.searchCategory])

			let params = {
				filters,
				include: this.templateInclude
			}

			this.getJSON('FormMarketplaceTemplate/get', params).then(response => {
				if (response.success) {
					vm.allTemplates = response.data
					vm.mutateTemplates(vm.allTemplates)
				}

			})

		},

		fetchData() {
			/**
			 * Fetch the marketplace categories (for the search dropdown), featured templates,
			 * every template, and the company's local categories (for the import modal)
			 */

			let vm = this

			let params = {
				filters: [ ['is_featured', true] ],
				include: this.templateInclude
			}

			let promises = [
				this.getJSON('FormMarketplaceCategory/get'),
				this.getJSON('FormMarketplaceTemplate/get', { include: this.templateInclude }),
				this.getJSON('FormMarketplaceTemplate/get', params),
				this.getJSON('FormTemplateCategory/get')
			]

			Promise.all(promises).then(responses => {

				if (responses[0].success)
					vm.categories = responses[0].data

				if (responses[1].success) {
					vm.allTemplates = responses[1].data
					vm.mutateTemplates(vm.allTemplates)
				}

				if (responses[2].success) {
					vm.featuredTemplates = responses[2].data
					vm.mutateTemplates(vm.featuredTemplates)
				}

				if (responses[3].success) {
					vm.companyCategories = responses[3].data
				}

			})
		}
	},

	created() {
		this.fetchData()
	}
}
</script>

<style type="text/css" scoped>



.search-bar {
	width: 350px;
}

.main-body {
	padding: 25px 150px;
}


@media (max-width: 800px) {

	.main-body {
		padding: 10px 0;
	}

}

</style>
